import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";

var _subscribers = /*#__PURE__*/new WeakMap();

export var VitalMetric = /*#__PURE__*/function () {
  function VitalMetric(name, roundingMethod) {
    _classCallCheck(this, VitalMetric);

    _subscribers.set(this, {
      writable: true,
      value: new Set()
    });

    _defineProperty(this, "history", []);

    this.name = name;
    this.attrs = {};
    this.roundingMethod = typeof roundingMethod === 'function' ? roundingMethod : Math.floor;
  }

  _createClass(VitalMetric, [{
    key: "update",
    value: function update(_ref) {
      var value = _ref.value,
          _ref$attrs = _ref.attrs,
          attrs = _ref$attrs === void 0 ? {} : _ref$attrs;
      if (value === undefined || value === null || value < 0) return;
      var state = {
        value: this.roundingMethod(value),
        name: this.name,
        attrs: attrs
      };
      this.history.push(state);

      _classPrivateFieldGet(this, _subscribers).forEach(function (cb) {
        try {
          cb(state);
        } catch (e) {// ignore errors
        }
      });
    }
  }, {
    key: "current",
    get: function get() {
      return this.history[this.history.length - 1] || {
        value: undefined,
        name: this.name,
        attrs: {}
      };
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.current.value >= 0;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this = this;

      var buffered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (typeof callback !== 'function') return;

      _classPrivateFieldGet(this, _subscribers).add(callback); // emit full history on subscription ("buffered" behavior)


      if (this.isValid && !!buffered) this.history.forEach(function (state) {
        callback(state);
      });
      return function () {
        _classPrivateFieldGet(_this, _subscribers).delete(callback);
      };
    }
  }]);

  return VitalMetric;
}();